import * as React from "react";
const SvgComponent = ({ strokeColor = "#90EE90", ...props }) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 176.4 103.8"
    style={{
      enableBackground: "new 0 0 176.4 103.8",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">
      {"\n\t.iso_front_left{fill:none;stroke:" +
        strokeColor +
        ";stroke-width:0.6046;stroke-miterlimit:10;}\n\t.st1{display:none;fill:none;stroke:" +
        strokeColor +
        ";stroke-width:0.6046;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:" +
        strokeColor +
        ";stroke-width:0.6046;stroke-miterlimit:9.9964;}\n\t.st3{fill:none;stroke:" +
        strokeColor +
        ";stroke-width:0.6676;stroke-miterlimit:10.0006;}\n"}
    </style>
    <g id="Layer_1_00000128466083391161417530000010368623512704411069_">
      <g id="Layer_1_00000105402755068823616560000004557812799981369480_">
        <g id="Layer_4">
          <path
            className="iso_front_left"
            d="M63.9,55.8c0.5-1.2,0.2-1.5,1.2-3c0.5-3.2,26.4-17.2,27.6-16.9"
          />
          <g id="Layer_2_00000058550286679134392200000015710878381421217926_">
            <line className="st1" x1={98.5} y1={83.7} x2={157} y2={65.3} />
            <path className="iso_front_left" d="M73.1,94.6c-17.7,2-57.7-4.5-61.5-5.7" />
          </g>
        </g>
        <path
          className="iso_front_left"
          d="M56.2,61.3L44,61c-1.5,0-2.5-1.2-2.5-2.7l0,0c0-4.2,4-7.2,8-7.2l12.2,0.2c1.5,0,2.5,1.2,2.5,2.7l0,0 C63.9,58,60.4,61.3,56.2,61.3z"
        />
      </g>
      <g id="Layer_2_00000139272764159754113790000002209323745162615683_">
        <g id="Layer_1_00000103222774645540541050000005139477364094571910_">
          <g id="Layer_4_00000049934109083756324810000015099088110705302955_">
            <path
              className="iso_front_left"
              d="M95.5,56.3c8,3.2,7.5,19.7,8,23.6c0,0,0,1.7,0,2.2"
            />
            <path
              className="iso_front_left"
              d="M77.3,74c-0.2-0.2-5.5-7-6.7-8.7c0,0-7.2-6.5-8-7.5"
            />
            <path
              className="iso_front_left"
              d="M94.5,84.9c1-7-2.2-12.7-6-12.9c-4-0.2-8,4.7-8.5,11.7c-1,7,2.2,12.7,6,12.9C90,97.1,93.5,91.9,94.5,84.9z"
            />
            <path
              className="iso_front_left"
              d="M166.9,63.8c0,4.5-1.7,8.5-4,8.5c-2.2,0-4-4-4-8.5s1.7-8.5,4-8.5C165.2,55.3,166.9,59.3,166.9,63.8"
            />
            <g id="Layer_2_00000035522350009171966180000007139185092383136160_">
              <path className="iso_front_left" d="M93,35.9c-3.2-0.5-21.4-2.2-22.4-2.7" />
              <path className="iso_front_left" d="M72.1,60.5" />
              <path className="iso_front_left" d="M56.4,62" />
              <path className="iso_front_left" d="M56.4,62" />
              <path className="iso_front_left" d="M68.6,55.6" />
              <path className="iso_front_left" d="M56.7,59" />
            </g>
          </g>
          <path className="iso_front_left" d="M110.2,10.5c-0.2,0.2-16.4,24.9-17.2,25.6" />
          <path className="iso_front_left" d="M162,46.6c-3-0.2-5.5,8-7,19.7" />
          <path className="iso_front_left" d="M93,35.9c0.2,2.5,2.2,15.9,2.5,20.7" />
        </g>
        <ellipse
          transform="matrix(9.653204e-02 -0.9953 0.9953 9.653204e-02 -6.6058 161.759)"
          className="st2"
          cx={85.8}
          cy={84.5}
          rx={1.2}
          ry={1}
        />
        <ellipse className="st3" cx={162.9} cy={63.8} rx={0.5} ry={0.5} />
        <path
          className="iso_front_left"
          d="M72.8,94.9l0.2-3.2C74.6,78,79.8,63,89.5,60.8l1.7-0.2c8.5,0.2,9,9.7,9.7,17.4l0.2,5"
        />
        <path
          className="iso_front_left"
          d="M83.3,64.3h3C99.5,64.8,98.5,80.2,98,83.4l-0.2,2.5c-2.5,14.9-13.9,19.9-22.9,13.7c-3-2.2-3.7-4.7-3.7-4.7"
        />
        <path
          className="iso_front_left"
          d="M152.2,67.3L152.2,67.3c0.2,1,1.2,5,3.7,6.5c2.2,1.7,9,3.7,11.5-5.5c0.2-1.2,0.5-2.7,0.5-4.2 c0.2-1.2-0.2-4.7-0.2-5.2c-0.2-1.7-1.2-6.5-5.5-6.7h-2"
        />
        <path
          className="iso_front_left"
          d="M167.9,61.8v-0.5l-0.5-7c-0.5-4-1.2-5-2.5-5.5c-0.5-0.2-1-0.2-1.5-0.2c-3.2,0.7-5.2,6.7-6.5,17.2"
        />
      </g>
      <path className="iso_front_left" d="M42,55.8c-1.7,0-28.1-2.5-29.1-2.5" />
      <polyline
        className="iso_front_left"
        points="14.3,67 26.3,68.5 25.3,76.2 12.9,74.7  "
      />
    </g>
    <g id="Layer_3">
      <path
        className="iso_front_left"
        d="M111.2,27.7h-1.2l-3.7,3.2l-0.5,0.5l2.2,1c1.5,0.5,3.2,1,4.7,0.2l1.5-0.5c1-0.2,1.7-0.5,2.7-0.5l7.5-0.5 c1,0,1.5-0.5,1.5-1.5l0.2-4c0-0.5-0.2-1.2-1.2-1.5l-4.7-1.5c-1.5-0.2-3.2-0.2-4.7,0.5l-2.2,1.5L111.2,27.7z"
      />
      <line className="iso_front_left" x1={111.2} y1={27.7} x2={114.2} y2={32.4} />
    </g>
    <line className="iso_front_left" x1={157.2} y1={65.8} x2={101} y2={82.9} />
  </svg>
);
export default SvgComponent;
